import { render, staticRenderFns } from "./MedicoesModal.vue?vue&type=template&id=5f5b2f5d&scoped=true"
import script from "./MedicoesModal.vue?vue&type=script&lang=js"
export * from "./MedicoesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5b2f5d",
  null
  
)

export default component.exports